export default __webpack_public_path__ + "static/Efficacy-Hgb_increase-chart-sm@2x-989c48f6330aee56dbf49bf7b72335eb.png";